import { title } from "process";

export const navLinkMap = {
  Detect: "detecting",
  Move: "moving",
  Capture: "capturing",
  Process: "processing",
  "Sutter TKO": "tko",
  Overview: "overview",
  Specifications: "specs",
  overview: "Overview",
  specs: "Specifications",
  caseStudies: "Case Studies",
  "Case Studies" : "caseStudies",
  // AccuTilt: "accutilt",
  // accutilt: "AccuTilt",
  "Data Systems": "systems",
  Team: "team",
  Facilities: "facilities",
  Observatories: "observatories",
  News: "news",
  Featured: "featured",
  Articles: "articles",
  Videos: "videos",
  Theia: "theia",
  "Capture Bag": "capturebag",
  DAQAstra: "daqastra",
  detecting: "Detect",
  moving: "Move",
  capturing: "Capture",
  processing: "Process",
  tko: "Sutter TKO",
  systems: "Data Systems",
  team: "Team",
  facilities: "Facilities",
  observatories: "Observatories",
  news: "News",
  featured: "Featured",
  articles: "Articles",
  videos: "Videos",
  theia: "Theia",
  capturebag: "Capture Bag",
  daqastra: "DAQAstra",
  Podcasts: "podcasts",
  podcasts: "Podcasts",
  "Public Appearances": "publicAppearances",
  publicAppearances: "Public Appearances",
  rnd: "R&D",
  "R&D": "rnd",
};

export const navLinks = {
  capabilities: {
    name: "Capabilities",
    link: "capabilities",
    dropdowns: {
      detecting: { title: "Detect", link: "#detecting" },
      capturing: { title: "Capture", link: "#capturing" },
    },
  },
  rnd: {
    name: "R&D",
    link: "rnd",
    dropdowns: {
      moving: { title: "Move", link: "#moving" },
      processing: { title: "Process", link: "#processing" },
    },
  },
  products: {
    name: "Products",
    link: "products",
    dropdowns: {
      tko: { title: "Sutter TKO", link: "tko" },
      // accutilt: { title: "AccuTilt", link: "accutilt" },
      theia: { title: "Theia", link: "theia" },
      capturebag: { title: "Capture Bag", link: "capturebag" },
      daqastra: { title: "DAQAstra", link: "daqastra" },
    },
  },
  company: {
    name: "Company",
    link: "company",
    dropdowns: {
      team: { title: "Team", link: "team" },
      facilities: { title: "Facilities", link: "facilities" },
      observatories: { title: "Observatories", link: "observatories" },
    },
  },
  news: {
    name: "News",
    link: "news",
    optional: { title: "Events", link: "top" },
    dropdowns: {
      featured: { title: "Featured", link: "featured" },
      articles: { title: "Articles", link: "articles" },
      videos: { title: "Videos", link: "videos" },
      podcasts: { title: "Podcasts", link: "podcasts" },
      publicAppearances: {
        title: "Public Appearances",
        link: "publicAppearances",
      },
    },
  },
  contact: {
    name: "Contact Us",
    link: "contact",
    dropdowns: null,
  },
};
